import { render } from "./newsPage.vue?vue&type=template&id=d3c4bebc&scoped=true"
import script from "./newsPage.vue?vue&type=script&lang=js"
export * from "./newsPage.vue?vue&type=script&lang=js"

import "./newsPage.vue?vue&type=style&index=0&id=d3c4bebc&scoped=true&lang=css"
import "./newsPage.vue?vue&type=style&index=1&id=d3c4bebc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c4bebc"]])

export default __exports__